<template>
  <div :class="`checkout-stepper ${lowerzindex ? 'lower-zindex' : ''}`">
    <div
      ref="stepper"
      :class="`stepper-container order-summary--${orderSummary}`"
    >
      <div class="stepper-container__inner">
        <div class="stepper">
          <div class="container-fluid">
            <div class="row">
              <div class="col">
                <div :class="`stepper-inner`">
                  <div class="stepper-inner__trigger">
                    <!-- Stepper Trigger (mobile) -->
                    <div class="stepper-container__triggers">
                      <div>
                        <button
                          class="btn btn-info"
                          @click="toggleOrderSummary"
                        >
                          View Order
                        </button>
                      </div>
                      <div>
                        <transition
                          name="simple-fade"
                          mode="out-in"
                          data-cy="order-button-mobile"
                        >
                          <button
                            v-if="isOrderFulfilled"
                            class="btn btn-success"
                            @click="checkoutClicked()"
                          >
                            {{ checkoutButtonText }}
                          </button>
                          <button
                            v-else
                            class="btn btn-primary order-unfulfilled"
                            disabled
                          >
                            <span class="checkout-span">
                              <font-awesome-icon icon="credit-card" />
                            </span>
                            <span v-if="isCustomOrder">
                              {{ customOrderProductCount }} / {{ orderTypes[selectedOrderType].frequencies[selectedFrequency].quantities[selectedQuantity].customQuantity }}
                            </span>
                            <!-- Finish Order -->
                          </button>
                        </transition>
                      </div>
                    </div>
                    <!-- / Stepper Trigger -->
                  </div>

                  <transition-group
                    tag="div"
                    class="stepper-inner__steps"
                    name="move"
                  >
                    <!-- Step 1 -->
                    <div
                      key="stepper-step-1"
                      :class="{stepComplete: getCurrentStep > 1}"
                      class="stepper-step"
                    >
                      <a
                        v-scroll-to="'#somnambulist-step-1'"
                        href="#"
                      >
                        <div
                          class="stepper-step-content"
                          data-cy="clubname"
                        >
                          <div class="stepper-step-title">
                            {{ getLangString('orderTypeStepper') }}
                          </div>
                          <div
                            class="stepper-step-type"
                            data-cy="value"
                          >
                            <h4>{{ (getCurrentStep > 1) ? (orderTypes[selectedOrderType].title || 'None') : 'None' }}</h4>
                          </div>
                        </div>
                        <step-icon :checked="getCurrentStep > 1" />
                      </a>
                    </div>
                    <!-- / Step 1 -->
                    <!-- Step 2 -->
                    <div
                      key="stepper-step-2"
                      :class="{stepComplete: getCurrentStep > 2}"
                      class="stepper-step"
                    >
                      <a
                        v-scroll-to="'#somnambulist-step-2'"
                        href="#"
                      >
                        <div
                          class="stepper-step-content"
                          data-cy="frequency"
                        >
                          <div class="stepper-step-title">
                            {{ getLangString('frequencyStepper') }}
                          </div>
                          <div
                            class="stepper-step-type"
                            data-cy="value"
                          >
                            <h4>{{ (getCurrentStep > 2) ? (frequency(selectedFrequency) || 'None') : 'None' }}</h4>
                          </div>
                        </div>
                        <step-icon :checked="getCurrentStep > 2" />
                      </a>
                    </div>
                    <!-- / Step 2 -->
                    <!-- Step 3 -->
                    <div
                      key="stepper-step-3"
                      :class="{stepComplete: getCurrentStep > 3}"
                      class="stepper-step"
                    >
                      <a
                        v-scroll-to="'#somnambulist-step-3'"
                        href="#"
                      >
                        <div
                          class="stepper-step-content"
                          data-cy="quantity"
                        >
                          <div class="stepper-step-title">
                            {{ getLangString('quantityStepper') }}
                          </div>
                          <div
                            class="stepper-step-type"
                            data-cy="value"
                          >
                            <h4>{{ (getCurrentStep > 3) ? (quantity(selectedQuantity) || 'None') : 'None' }}</h4>
                          </div>
                        </div>
                        <step-icon :checked="getCurrentStep > 3" />
                      </a>
                    </div>
                    <!-- / Step 3 -->
                    <!-- Step 4 -->
                    <div
                      v-if="isCustomOrder"
                      key="stepper-step-4"
                      :class="{stepComplete: isOrderFulfilled}"
                      data-cy="customquantity"
                      class="stepper-step"
                    >
                      <a
                        v-scroll-to="'#somnambulist-step-4'"
                        href="#"
                      >
                        <div
                          class="stepper-step-content stepper-step-nowrap"
                          data-cy="customquantity"
                        >
                          <div class="stepper-step-title">
                            {{ getLangString('customStepper') }}
                          </div>
                          <div
                            v-if="getCurrentStep > 3"
                            class="stepper-step-type"
                          >
                            <h4
                              :class="{ 'fulfilled': isOrderFulfilled }"
                              class="quantity"
                            >
                              <template v-if="isFixedQuantity">
                                {{ customOrderProductCount }} / {{ orderTypes[selectedOrderType].frequencies[selectedFrequency].quantities[selectedQuantity].customQuantity }}
                              </template>
                              <template v-else>
                                {{ customOrderProductCount }} {{ customOrderProductCount === 1 ? 'Bottle' : 'Bottles' }}
                                <span
                                  class="whatsthis"
                                  @click="toggleShowWhatsThis"
                                >
                                  <span class="icon-container">
                                    <font-awesome-icon
                                      :icon="[ 'far', 'circle-question' ]"
                                      class="icon"
                                      fixed-width
                                    />
                                  </span>
                                  <span
                                    v-if="showwhatsthis"
                                    class="whatsthis-popover"
                                  >
                                    <span class="whatsthis-popover-inner">
                                      <span class="whatsthis-popover-inner-title">Quantity</span>
                                      <span class="whatsthis-popover-inner-body">
                                        Minimum of {{ customMinQty }} bottles.
                                        <template v-if="hasCustomIncQty"><br/>(With increments of {{ customIncQty }} after)</template>
                                        <template v-if="hasCustomMaxQty"><br/>Maximum of {{ customMaxQty }} bottles.</template>
                                      </span>
                                    </span>
                                  </span>
                                </span>
                              </template>
                            </h4>
                          </div>
                          <div
                            v-else
                            class="stepper-step-type"
                          >
                            <h4>None</h4>
                          </div>
                        </div>
                        <step-icon :checked="isOrderFulfilled" />
                      </a>
                    </div>
                    <!-- / Step 4 -->
                    <!-- Step 5 -->
                    <div
                      key="stepper-step-5"
                      class="stepper-step price"
                    >
                      <div
                        class="stepper-step-content"
                        data-cy="price"
                      >
                        <div class="stepper-step-title">
                          {{ getLangString('priceStepper') }}
                        </div>
                        <h4 class="price-value">
                          <transition-group name="list">
                            <div
                              v-if="showRrp"
                              key="1"
                              class="original-price"
                              data-cy="original-price"
                            >
                              {{ getRrpString }}
                            </div>
                            <div
                              key="2"
                              class="discounted-price"
                              data-cy="discounted-price"
                            >
                              {{ getClubPriceString }} + shipping
                            </div>
                          </transition-group>
                        </h4>
                      </div>
                    </div>
                    <!-- / Step 5 -->
                    <!-- Step 6 -->
                    <div
                      key="stepper-step-6"
                      class="stepper-step checkout"
                      data-cy="order-button-desktop"
                    >
                      <div class="stepper-step-content">
                        <transition
                          name="simple-fade"
                          mode="out-in"
                        >
                          <div
                            v-if="isOrderFulfilled"
                            key="success"
                          >
                            <button
                              class="btn btn-success desktop-checkout-button"
                              @click="checkoutClicked()"
                            >
                              <div class="checkout-icon">
                                <font-awesome-icon icon="credit-card" />
                              </div>
                              <div class="checkout-text">
                                {{ checkoutButtonText }}
                              </div>
                            </button>
                          </div>
                          <div
                            v-else
                            key="fail"
                          >
                            <button
                              class="btn btn-primary desktop-checkout-button"
                              disabled
                            >
                              <div class="checkout-icon">
                                <span>
                                  <font-awesome-icon icon="credit-card" />
                                </span>
                              </div>
                              <div class="checkout-text">
                                {{ checkoutButtonText }}
                              </div>
                            </button>
                          </div>
                        </transition>
                      </div>
                    </div>
                    <!-- / Step 6 -->
                  </transition-group>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import StepIcon from './StepIcon'
import CartArrowIcon from '../../svgs/CartArrowIcon'

import VueScrollTo from 'vue-scrollto'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faCircleQuestion } from '@fortawesome/free-regular-svg-icons'

library.add(faCircleQuestion)

export default {
  name: 'stepper',
  components: {
    StepIcon,
    CartArrowIcon
  },
  props: {
    lowerzindex: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      orderSummary: 'hidden',
      showwhatsthis: false
    }
  },
  computed: {
    ...mapState('somnambulistui', [
      'orderTypes',
      'selectedOrderType',
      'selectedFrequency',
      'selectedQuantity',
      'showContentCreator',
      'orderId'
    ]),
    ...mapGetters('somnambulistui', [
      'isFixedQuantity',
      'isCustomOrder',
      'showRrp',
      'customOrderProductCount',
      'isOrderFulfilled',
      'getCurrentStep',
      'getClubPriceFloat',
      'getClubPriceString',
      'getSelectedQuantityObject',
      'getRrpString',
      'getRrpFloat',
      'getLangString',
      'getEventReportData'
    ]),
    ...mapGetters('user', ['isLoggedIn']),
    customMinQty() {
      return this.getSelectedQuantityObject.customQuantity
    },
    customMaxQty() {
      return this.getSelectedQuantityObject.customQuantityMax
    },
    customIncQty() {
      return this.getSelectedQuantityObject.customQuantityInc
    },
    hasCustomIncQty() {
      return this.getSelectedQuantityObject.customQuantityInc > 1
    },
    hasCustomMaxQty() {
      return !this.isFixedQuantity && this.customMaxQty > 0
    },
    checkoutButtonText() {
      if (this.orderId) {
        return this.getLangString('confirmChangesButton')
      }
      else {
        return this.getLangString('completeOrderButton')
      }
    }
  },
  watch: {
    selectedQuantity: function() {
      this.showwhatsthis = !this.isFixedQuantity
    }
  },
  mounted() {
    if (typeof document !== 'undefined') {
      if (this.$store.state.somnambulistui.scrollBottom) {
        VueScrollTo.scrollTo(this.$refs.continueButton)
        this.$store.commit('somnambulistui/RESET_SCROLL')
      }
    }

    if (!this.isMobile() && this.orderSummary === 'hidden') {
      this.orderSummary = 'viewable'
    }
  },
  methods: {
    ...mapActions('somnambulistui', ['updateBlob', 'changeOrder']),
    frequency(val) {
      return this.$store.getters['somnambulistui/frequency'](val)
    },
    quantity(val) {
      return this.$store.getters['somnambulistui/quantity'](val)
    },
    isMobile() {
      return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
    },
    toggleOrderSummary() {
      if (this.orderSummary === 'viewable') {
        this.orderSummary = 'hidden'
        return
      }

      if (this.orderSummary === 'hidden') {
        this.orderSummary = 'viewable'
        return
      }

      return null
    },
    checkoutClicked() {
      this.$store.commit('somnambulistui/SET_SCROLL_TOP', true)
      this.$store.commit('somnambulistui/SET_UPDATING_ORDER', false)
      const event = this.orderId ? 'wine_club_selection_update' : 'wine_club_selection'
      this.$eventHub.$emit('eventReport', { event, wine_club: this.getEventReportData })
      this.$emit('completed', null)
    },
    toggleShowWhatsThis() {
      this.showwhatsthis = !this.showwhatsthis
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@scss/custom.scss";

.whatsthis {
  position: relative;
  padding: 0.5rem;
}

.whatsthis-popover {
  position: absolute;
  display: block;
  bottom: 2rem;
  right: 0;
  background-color: var(--main-site-header-dropdown-background-color);
  box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.25);
  filter: drop-shadow(-1px 6px 3px rgba(50, 50, 0, 0.5));
  &:after {
    width: 1.5em;
    height: 0.75rem;
    background: var(--main-site-header-dropdown-background-color);
    -webkit-clip-path: polygon(100% 0%, 0% 0%, 50% 100%);
    clip-path: polygon(100% 0%, 0% 0%, 50% 100%);
    position: absolute;
    left: 0;
    right: 0.5rem;
    bottom: -0.75rem;
    z-index: 1;
    transform: translate(0, 0em);
    transition: translate, 0.3s;
    content: " ";
    margin-left: auto;
  }
  margin-bottom: 1em;
  z-index: 1000;
  text-align: left;
  min-width: 15em;
  float: left;
  border-radius: 0.5rem;

  .whatsthis-popover-inner {
    color: var(--main-primary);
    display: block;
    padding: 1rem;

    .whatsthis-popover-inner-title {
      font-size: 1.2rem;
      display: block;
      margin-bottom: 1rem;
    }
  }
}

.container-fluid { max-width: 1400px; }

.checkout-stepper {
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 3;

  &.lower-zindex {
    position: relative;
    z-index: initial;
  }
}

.stepper-container {
  &::before {
    content: '';
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 980;
    -webkit-backdrop-filter: blur(4px) contrast(40%);
    background-color: rgba(#000, 0.25);
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.25s ease;

    @include media-breakpoint-up(lg) {
      display: none;
    }
  }

  // Mobile order summary active state
  &.order-summary {
    &--viewable {
      &::before {
        opacity: 1;
        visibility: visible;
        pointer-events: all;
      }

      .stepper-container__triggers {
        z-index: 999;
      }

      .stepper-inner__steps {
        --translateY: 0;
        --opacity: 1;
      }
    }
  }

  &__triggers {
    display: flex;
    border-radius: 0;
    position: relative;
    touch-action: manipulation;

    @include media-breakpoint-up(lg) {
      display: none;
    }

    & > div {
      flex: 1;

      button { width: 100%; }
    }

    button {
      border-radius: 0;
      padding: 1em 0;
      border: none;
      outline: none;

      &.btn-success {
        animation: checkout-pulse 2s infinite;
      }

      &.order-unfulfilled {
        opacity: 1;
        background-color: #000;
        // opacity: 0.4;

        span.checkout-span {
          display: inline-block;
          position: relative;
          opacity: 0.6;

          &::after {
            content: '';
            position: absolute;
            width: 30px;
            height: 2px;
            background-color: #fff;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%) rotate(-45deg);
          }
        }
      }
    }
  }

  .stepper {
    // background: var(--main-card-background-color);
    box-shadow: 0px -3px 10px 0px #0000000d;
    width: 100%;
    border-radius: 3px;

    @include media-breakpoint-up(lg) {
      background-color: #fff;
    }

    &-inner {
      margin: 0 -15px;

      &__steps {
        --translateY: 100%;
        --opacity: 0;

        transform: translateY(var(--translateY));
        opacity: var(--opacity);
        position: absolute;
        bottom: 58px;
        left: 0;
        right: 0;
        display: flex;
        flex-direction: column;
        pointer-events: none;
        width: 100%;
        transition: all 0.25s ease;
        z-index: 992;
        background-color: #fff;

        @include media-breakpoint-up(md) {
          // position: relative;
          // transform: none;
          flex-direction: row;
          flex-wrap: nowrap;
        }

        @include media-breakpoint-up(lg) {
          position: relative;
          bottom: 0;
          z-index: initial;
          pointer-events: all;

          --translateY: 0;
          --opacity: 1;
        }
      }
    }

    &-step {
      display: flex;
      flex-direction: column;
      position: relative;
      padding: 0.75em 1em;
      border: 0px;
      cursor: pointer;

      &:not(:last-child) {
        border-bottom: 1px solid var(--main-border-color);

        @include media-breakpoint-up(md) { border-bottom: 0px; }
      }

      &:not(:first-child) {
        @include media-breakpoint-up(md) { padding-left: 3em; }
      }

      @include media-breakpoint-up(md) {
        // flex: 3 0 0;
        flex: auto;
        justify-content: center;
        border: 0px;
        padding: 1em 2em 1em 1em;

        &:not(:last-child) { border-right: 1px solid var(--main-border-color); }
      }

      @include media-breakpoint-up(lg) { padding: 1.25em 2.5em 1.25em 1.25em; }

      &-type {
        h4 {
          font-size: 1.2em;
          text-align: left;
          margin: 0;

          @include media-breakpoint-up(md) { font-size: 0.875em; }
        }
      }

      &-title {
        text-align: left;
        font-size: 0.875em;
        font-weight: 600;
      }

      &.price { cursor: default; }

      &.checkout {
        display: none;

        @include media-breakpoint-up(lg) {
          display: flex;
        }
      }

      &.stepComplete {
        a {
          display: flex;
          align-items: center;
          text-decoration: none;

          .stepper-step-title { color: var(--main-heading-color); }
          .stepper-step-type { color: var(--main-wine-club-text-success-color); }
        }
      }

      a {
        display: flex;
        align-items: center;
        text-decoration: none;
        color: var(--main-heading-color);

        .stepper-step-title { color: var(--main-heading-color); }
        .stepper-step-type { color: var(--main-wine-club-text-warning-color); }
      }

      .quantity {
        color: var(--main-wine-club-text-warning-color);

        &.fulfilled { color: var(--main-wine-club-text-success-color); }
      }

      .price {
        &-label {
          color: var(--main-highlight-text-color);
        }

        &-value {
          font-size: 1.25em;
          font-weight: 600;
          text-align: left;

          @include media-breakpoint-up(lg) {
            font-size: 0.875em;
          }

          .original-price {
            display: inline-block;
            position: relative;
            color: var(--main-wine-club-text-warning-color);
            margin-right: 6px;

            &::before {
              position: absolute;
              content: "";
              color: var(--main-wine-club-text-warning-color);
              left: 0;
              top: 50%;
              right: 0;
              border-top: 2px solid;
              border-color: inherit;
              transform: rotate(-5deg);
            }
          }

          .discounted-price { display: inline-block; }
        }
      }

     ::v-deep .step-icon {
        margin-left: auto;
        width: 2.5em;
        height: 2.5em;

        @include media-breakpoint-up(md) {
          width: 2.5em;
          height: 2.5em;
          margin: 0;
          position: absolute;
          right: -1.25em;
        }

        @include media-breakpoint-up(lg) {
          width: 2.5em;
          height: 2.5em;
          right: -1.25em;
        }
      }
    }
  }
}

.stepper-container__triggers {
  .fade {
    &-enter-active,
    &-leave-active { transition: opacity 5s;}

    &-enter,
    &-leave-to { opacity: 0; }
  }
}

.stepper-step-nowrap {
  white-space: nowrap;
}

.checkout-container {
  .checkout {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 1.5rem 0;
    //background: var(--main-wine-club-complete-order-background);

    @include media-breakpoint-up(lg) { padding: 2rem 0; }

    .checkout-cart-button {
      @include hover-focus { background: var( --main-wine-club-complete-order-button-highlight-background); }

      cursor: pointer;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      background: var(--main-wine-club-complete-order-button-background);
      color: var(--main-wine-club-complete-order-button-text-color);
      font-size: 1.2em;
      padding: 1.5rem 2rem;
      border-radius: 3px;

      .checkout-icon { margin-right: 0.75em; }
    }
  }
}

.desktop-checkout-button {
  @include hover-focus { background: var( --main-wine-club-complete-order-button-highlight-background); }

  cursor: pointer;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  // background: var(--main-wine-club-complete-order-button-background);
  // background: #000;
  opacity: 1;
  // color: var(--main-wine-club-complete-order-button-text-color);
  font-size: 0.785em; // 14px
  padding: 0.875em 1.25rem;
  border-radius: 3px;
  cursor: pointer;

  &.btn-success {
    border: none;
    outline: none;
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);
    animation: desktop-checkout-pulse 2s infinite;
    transition: transform 0.25s ease;

    &:hover,
    &:active,
    &:focus {
      background: #42ba5e;
      transform: translateY(-2px);
    }
  }

  .checkout-icon {
    margin-right: 0.75em;

    span {
      display: inline-block;
      text-decoration: line-through;
      position: relative;
      opacity: 0.6;

      &::after {
        content: '';
        position: absolute;
        width: 20px;
        height: 2px;
        background-color: #fff;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) rotate(-45deg);
      }
    }

  }
}

@keyframes desktop-checkout-pulse {
  0% {
    background-color: #42ba5e;
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.2);
  }

  50% {
    background-color: #3ad45e;
    box-shadow: 0 0 0px 8px rgba(0, 0, 0, 0);
  }

  75% {
    background-color: #42ba5e;
  }

  100% {
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
    background-color: #42ba5e;
  }
}

@keyframes checkout-pulse {
  0% {
    background-color: #42ba5e;
  }

  50% {
    background-color: #3ad45e;
  }

  100% {
    background-color: #42ba5e;
  }
}

@keyframes icon-pulse {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 8px 6px rgba(255, 255, 255, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
  }
}

.simple-fade-enter-active, .simple-fade-leave-active {
  transition: opacity .3s ease;
  transition-delay: 0s;
}
.simple-fade-enter, .simple-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.stepper-step.checkout {
  flex-grow: 1;
}

.list-enter-active,
.list-leave-active,
.list-move {
  transition: 500ms cubic-bezier(0.59, 0.12, 0.34, 0.95);
  transition-property: opacity, transform;
}

.list-enter {
  opacity: 0;
  transform: translateX(-50px);
}

.list-enter-to {
  opacity: 1;
  transform: translateX(0);
}

.list-leave-active {
  position: absolute;
}

.list-leave-to {
  opacity: 0;
  transform: translateX(0);
}

.move-transition-move {
  transition: transform 1s;
}
</style>
